import '@/styles/app.scss'
import Vue from 'vue'
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import 'bootstrap-vue/src/icons.scss'

/**
 * Attached Boostrap Instance with Vue
 */
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
